// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 10 6%27%3e %3cpath stroke=%27%236B7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m1 1 4 4 4-4%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M1 5.917 5.724 10.5 15 1.5%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E5E7EB; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9CA3AF; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9CA3AF; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

.tooltip-arrow,.tooltip-arrow:before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

.tooltip-arrow {
  visibility: hidden;
}

.tooltip-arrow:before {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
}

[data-tooltip-style^='light'] + .tooltip > .tooltip-arrow:before {
  border-style: solid;
  border-color: #e5e7eb;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='top'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='right'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='bottom'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='left'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

.tooltip[data-popper-placement^='top'] > .tooltip-arrow {
  bottom: -4px;
}

.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow {
  top: -4px;
}

.tooltip[data-popper-placement^='left'] > .tooltip-arrow {
  right: -4px;
}

.tooltip[data-popper-placement^='right'] > .tooltip-arrow {
  left: -4px;
}

.tooltip.invisible > .tooltip-arrow:before {
  visibility: hidden;
}

[data-popper-arrow],[data-popper-arrow]:before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

[data-popper-arrow] {
  visibility: hidden;
}

[data-popper-arrow]:before {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
}

[data-popper-arrow]:after {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
  position: absolute;
  width: 9px;
  height: 9px;
  background: inherit;
}

[role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #4b5563;
}

[role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #4b5563;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow] {
  bottom: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow] {
  top: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow] {
  right: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow] {
  left: -5px;
}

[role="tooltip"].invisible > [data-popper-arrow]:before {
  visibility: hidden;
}

[role="tooltip"].invisible > [data-popper-arrow]:after {
  visibility: hidden;
}

[type='text'],[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}

[type='text']:focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 0px #fff, /*!*/ /*!*/ 0 0 0 calc(1px + 0px) #1C64F2, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #1C64F2;
}

input::-moz-placeholder, textarea::-moz-placeholder {
  color: #6B7280;
  opacity: 1;
}

input::placeholder,textarea::placeholder {
  color: #6B7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
}

select:not([size]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 0.75em 0.75em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[multiple] {
  background-image: none;
  background-image: initial;
  background-position: 0 0;
  background-position: initial;
  background-repeat: repeat;
  background-repeat: initial;
  background-size: auto auto;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: inherit;
          print-color-adjust: inherit;
}

[type='checkbox'],[type='radio'] {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #1C64F2;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  --tw-shadow: 0 0 rgba(0,0,0,0);
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: /*!*/ /*!*/ 0 0 0 2px #fff, /*!*/ /*!*/ 0 0 0 calc(2px + 2px) #1C64F2, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked,.dark [type='checkbox']:checked,.dark [type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 0.55em 0.55em;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

.dark [type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-color: currentColor;
  border-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px auto inherit;
}

input[type=file]::file-selector-button {
  color: white;
  background: #1F2937;
  border: 0;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 2rem;
  padding-right: 1rem;
  margin-left: -1rem;
  margin-right: 1rem;
}

input[type=file]::file-selector-button:hover {
  background: #374151;
}

.dark input[type=file]::file-selector-button {
  color: white;
  background: #4B5563;
}

.dark input[type=file]::file-selector-button:hover {
  background: #6B7280;
}

input[type="range"]::-webkit-slider-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-webkit-slider-thumb {
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-webkit-slider-thumb {
  background: #6B7280;
}

input[type="range"]:focus::-webkit-slider-thumb {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) rgba(164, 202, 254, 1px), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
  --tw-ring-opacity: 1px;
  --tw-ring-color: rgba(164, 202, 254, var(--tw-ring-opacity));
}

input[type="range"]::-moz-range-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-moz-range-thumb {
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-moz-range-thumb {
  background: #6B7280;
}

input[type="range"]::-moz-range-progress {
  background: #3F83F8;
}

input[type="range"]::-ms-fill-lower {
  background: #3F83F8;
}

.toggle-bg:after {
  content: "";
  position: absolute;
  top: 0.125rem;
  left: 0.125rem;
  background: white;
  border-color: #D1D5DB;
  border-width: 1px;
  border-radius: 9999px;
  height: 1.25rem;
  width: 1.25rem;
  transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;
  transition-duration: .15s;
  box-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
}

input:checked + .toggle-bg:after {
  transform: translateX(100%);;
  border-color: white;
}

input:checked + .toggle-bg {
  background: #1C64F2;
  border-color: #1C64F2;
}

  :root{
    /*--color-text-link: #003f7b;*/
    /*--color-text-button:  #003f7b;*/
  }

  .theme-bjoc {
    /* text definitions */
    --color-text-button:  #003f7b;
    --color-text-emailIcon: #176191;

    /* background definitions */
    --color-background-body: #79838A;
    --color-background-alsoVisit: #4a4a4a;
    --color-background-missionTile: #176191;
    --color-background-toggleButton: #176191;
    --color-background-articleButton: #176191;
    --color-background-actionButton: #003f7b;
    --color-background-volumeHeader: #176191;

    /* border definitions */
    --color-border-separator: #176191;
  }

  .theme-bjnano {
    /* text definitions */
    --color-text-button:  #003f7b;
    --color-text-emailIcon: #ED713B;

    /* background definitions */
    --color-background-body: #78726F;
    --color-background-alsoVisit: #4a4a4a;
    --color-background-missionTile: #ED713B;
    --color-background-toggleButton: #176191;
    --color-background-articleButton: #ED713B;
    --color-background-actionButton: #003f7b;
    --color-background-volumeHeader: #ED713B;

    /* border definitions */
    --color-border-separator: #ED713B;
  }


  html {
    font-family: Arial, sans-serif !important;
  }


  html {
    scroll-behavior: smooth;
  }

  p {
  margin-top: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

  h1 {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  h2 {
  margin-top: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  h2.aside-box {
  margin-top: 0.5rem;
}

  h3 {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

   h4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}


  .authors {
  margin-bottom: 0px;
  list-style-type: none;
  padding-top: 1rem;
  padding-left: 0px;
}

  .pwsButtonBlue {
  white-space: nowrap;
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgba(0, 63, 123, 1);
  border-color: rgba(0, 63, 123, var(--tw-border-opacity));
  padding: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  .pwsButtonWhite {
  white-space: nowrap;
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  padding: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .pwsButtonNav {
  white-space: nowrap;
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  text-transform: uppercase;
}

  .pwsButtonNav:hover {
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgba(0, 47, 92, 1);
  border-color: rgba(0, 47, 92, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 47, 92, 1);
  color: rgba(0, 47, 92, var(--tw-text-opacity));
}
  .pwsButtonNavMobile {
  margin-bottom: 0.5rem;
  display: block;
  white-space: nowrap;
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
  .pwsButtonNavMobile:hover {
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgba(0, 47, 92, 1);
  border-color: rgba(0, 47, 92, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 47, 92, 1);
  color: rgba(0, 47, 92, var(--tw-text-opacity));
}

  .pwsButtonNav.selected , .pwsButtonNavMobile.selected {
  --tw-border-opacity: 1;
  border-color: rgba(0, 47, 92, 1);
  border-color: rgba(0, 47, 92, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 47, 92, 1);
  color: rgba(0, 47, 92, var(--tw-text-opacity));
}

  .pwsPagerButton {
  margin-left: 0.5rem;
  display: flex;
  height: 2rem;
  width: 2rem;
  align-items: center;
  justify-content: center;
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .pwsPagerButton:hover {
  --tw-border-opacity: 1;
  border-color: rgba(0, 63, 123, 1);
  border-color: rgba(0, 63, 123, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  .pwsVolumePagerButton {
  margin-left: 0.25rem;
  display: flex;
  height: 2rem;
  align-items: center;
  justify-content: center;
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .pwsVolumePagerButton:hover {
  --tw-border-opacity: 1;
  border-color: rgba(0, 63, 123, 1);
  border-color: rgba(0, 63, 123, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  .pwsPagerButton.selected,
  .pwsVolumePagerButton.selected {
  --tw-border-opacity: 1;
  border-color: rgba(0, 63, 123, 1);
  border-color: rgba(0, 63, 123, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  .pwsPagerButton.disabled,
  .pwsVolumePagerButton.disabled {
  cursor: default;
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, 1);
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}

  .pwsPagerButton.disabled:hover,
  .pwsVolumePagerButton.disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, 1);
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(121, 131, 138, 1);
  background-color: rgba(121, 131, 138, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}



  .ga-toggle-button {
  border-radius: 9999px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .accordion-toggle-button {
  border-radius: 9999px;
  padding: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  input:focus::-moz-placeholder {
    color: transparent;
  }

  input:focus::placeholder {
    color: transparent;
  }

  select#searchOptions {
    appearance: none !important;
    -moz-appearance: none !important;
    -webkit-appearance: none !important
  }

  select#searchOptions {

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
  }

  /* ================================================== */
  /* Definitions for table iframes                */
  /* ================================================== */
  figure .table-responsive {
  min-height: .01%;
  overflow-x: auto;
}

  figure .table {
  margin-bottom: 1rem;
  width: 100%;
  font-size: 0.8125rem;
  line-height: 2rem;
}

  figure .table tr:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}


  figure .suppinfo-table tr:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}


  figure .table tr>td,
  figure .table tr>th {
  border-top-width: 0;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 400;
}

  figure .table .separator {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(55, 65, 81, 1);
  border-color: rgba(55, 65, 81, var(--tw-border-opacity));
}


  /* ================================================== */
  /* Definitions for the article content                */
  /* ================================================== */

  #articleContent p {
  font-size: 0.8125rem;
  line-height: 1.3125rem;
}

  #articleContent p.small {
  font-size: 0.75rem;
  line-height: 1rem;
}

  #articleContent a {
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  #articleContent h2 {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

  #articleContent h3 {
  margin-top: 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
}

  #articleContent .bs-separator {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(239, 239, 239, 1);
  border-color: rgba(239, 239, 239, var(--tw-border-opacity));
}

  #articleContent figure {
  width: 100%;
}

  #articleContent .table-responsive {
  min-height: .01%;
  overflow-x: auto;
}

  #articleContent .table {
  margin-bottom: 1rem;
  width: 100%;
  font-size: 0.8125rem;
  line-height: 2rem;
}

  #articleContent .table tr:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}


  #articleContent .suppinfo-table tr:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}


  #articleContent .table tr>td,
  #articleContent .table tr>th {
  border-top-width: 0;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 400;
}

  #articleContent .table .separator {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(55, 65, 81, 1);
  border-color: rgba(55, 65, 81, var(--tw-border-opacity));
}


  #articleContent .suppinfo-table tr>td,
  #articleContent .suppinfo-table tr>th {
  border-top-width: 0;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 400;
}

  #articleContent .singleLicense a {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  text-decoration-line: underline;
}

  #articleContent .equation {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

  #articleContent ul {
  margin-left: 1.5rem;
  margin-top: 1rem;
  list-style-type: square;
}

  #articleContent ul li {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

  #articleContent ol {
  margin-left: 1.5rem;
  margin-top: 1rem;
  list-style-type: decimal;
}

  #articleContent ol li {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

  /* ================================================== */
  /* Definitions for the static content                */
  /* ================================================== */

  .sc h2 {
  margin-top: 1.5rem;
}

  .sc h3 {
  margin-top: 1rem;
}
  .sc .margin-top__normal {
  margin-top: 1rem;
}

  .sc .margin-top__small {
  margin-top: 0.5rem;
}


  .sc .margin-bottom__large {
  margin-bottom: 4rem;
}

  .sc .narrow {
  margin-bottom: 0.5rem;
  margin-top: 1rem;
  list-style-type: square;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

  .sc ul {
  margin-top: 1rem;
  list-style-type: square;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

  .sc ul li {
  margin-top: 0.5rem;
}

  .sc a {
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  .sc table {
  margin-top: 1rem;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

  .sc table tr {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(243, 244, 246, 1);
  border-color: rgba(243, 244, 246, var(--tw-border-opacity));
  padding: 1rem;
}

  .sc table tr:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}

  .sc table tr > td {
  padding: 0.5rem;
}

  .sc .toc-list {
  margin-left: 1.5rem;
  margin-top: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}
  .sc ol.decimal {
  list-style-type: decimal;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

  .sc ol.decimal ol.lower-alpha {
  margin-left: 1rem;
  list-style-type: lower-alpha;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

  /*.sc ol.decimal li, ol.lower-alpha li {*/
  /*  @apply py-0.5 text-sm*/
  /*}*/

  .sc .top {
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgba(227, 35, 70, 1);
  color: rgba(227, 35, 70, var(--tw-text-opacity));
}

  .series-sc {
  font-size: 0.8125rem;
  line-height: 1.3125rem;
}

  .series-sc p {
  font-size: 0.8125rem;
  line-height: 1.3125rem;
}

  .series-sc a {
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}

  .series-sc ul {
  margin-top: 1rem;
  list-style-type: square;
  padding-left: 1rem;
  padding-right: 1rem;
}

  .series-sc ul li {
  margin-top: 0.5rem;
}

  .series-sc ol {
  margin-top: 1rem;
  list-style-type: decimal;
  padding-left: 1rem;
  padding-right: 1rem;
}

  .series-sc ol li {
  margin-top: 0.5rem;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(63, 131, 248, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(63, 131, 248, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 480px) {

  .container {
    max-width: 480px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 970px) {

  .container {
    max-width: 970px;
  }
}
@media (min-width: 1440px) {

  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-\\[60px\\] {
  bottom: 60px;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-20 {
  top: 5rem;
}
.top-4 {
  top: 1rem;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1055\\] {
  z-index: 1055;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.col-span-6 {
  grid-column: span 6 / span 6;
}
.row-span-2 {
  grid-row: span 2 / span 2;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-12 {
  margin-left: 3rem;
  margin-right: 3rem;
}
.mx-14 {
  margin-left: 3.5rem;
  margin-right: 3.5rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-20 {
  margin-left: 5rem;
  margin-right: 5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.table-row {
  display: table-row;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-1\\/2 {
  height: 50%;
}
.h-1\\/3 {
  height: 33.333333%;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-2\\/3 {
  height: 66.666667%;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-modal {
  height: calc(100% - 2rem);
}
.max-h-12 {
  max-height: 3rem;
}
.max-h-16 {
  max-height: 4rem;
}
.max-h-4 {
  max-height: 1rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-\\[3\\.5rem\\] {
  width: 3.5rem;
}
.w-full {
  width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-full {
  max-width: 100%;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(-100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), -100%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), 100%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-none {
  transform: none;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.list-decimal {
  list-style-type: decimal;
}
.list-square {
  list-style-type: square;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-end {
  justify-items: end;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.-space-x-px > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * 0);
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * (1 - 0));
  margin-left: calc(-1px * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(-1px * calc(1 - 0));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * 0);
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * (1 - 0));
  margin-left: calc(0.25rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.25rem * calc(1 - 0));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * 0);
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - 0));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - 0));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * (1 - 0));
  margin-top: calc(0.5rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.5rem * calc(1 - 0));
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * 0);
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.self-center {
  align-self: center;
}
.justify-self-start {
  justify-self: start;
}
.justify-self-end {
  justify-self: end;
}
.justify-self-center {
  justify-self: center;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  word-wrap: break-word;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0;
}
.border-2 {
  border-width: 2px;
}
.border-3 {
  border-width: 3px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-none {
  border-style: none;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, 1);
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgba(28, 100, 242, 1);
  border-color: rgba(28, 100, 242, var(--tw-border-opacity));
}
.border-blue-700 {
  --tw-border-opacity: 1;
  border-color: rgba(26, 86, 219, 1);
  border-color: rgba(26, 86, 219, var(--tw-border-opacity));
}
.border-bsBlue {
  --tw-border-opacity: 1;
  border-color: rgba(0, 47, 92, 1);
  border-color: rgba(0, 47, 92, var(--tw-border-opacity));
}
.border-bsButtonColor {
  --tw-border-opacity: 1;
  border-color: rgba(23, 97, 145, 1);
  border-color: rgba(23, 97, 145, var(--tw-border-opacity));
}
.border-bsFooterColor {
  --tw-border-opacity: 1;
  border-color: rgba(74, 74, 74, 1);
  border-color: rgba(74, 74, 74, var(--tw-border-opacity));
}
.border-bsLinkColor {
  --tw-border-opacity: 1;
  border-color: rgba(0, 63, 123, 1);
  border-color: rgba(0, 63, 123, var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgba(243, 244, 246, 1);
  border-color: rgba(243, 244, 246, var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgba(224, 36, 36, 1);
  border-color: rgba(224, 36, 36, var(--tw-border-opacity));
}
.border-skin-separator {
  border-color: var(--color-border-separator);
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 251, 235, 1);
  background-color: rgba(255, 251, 235, var(--tw-bg-opacity));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(26, 86, 219, 1);
  background-color: rgba(26, 86, 219, var(--tw-bg-opacity));
}
.bg-bsBackground {
  --tw-bg-opacity: 1;
  background-color: rgba(121, 131, 138, 1);
  background-color: rgba(121, 131, 138, var(--tw-bg-opacity));
}
.bg-bsButtonColor {
  --tw-bg-opacity: 1;
  background-color: rgba(23, 97, 145, 1);
  background-color: rgba(23, 97, 145, var(--tw-bg-opacity));
}
.bg-bsFooterColor {
  --tw-bg-opacity: 1;
  background-color: rgba(74, 74, 74, 1);
  background-color: rgba(74, 74, 74, var(--tw-bg-opacity));
}
.bg-bsLinkColor {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 63, 123, 1);
  background-color: rgba(0, 63, 123, var(--tw-bg-opacity));
}
.bg-bsRed {
  --tw-bg-opacity: 1;
  background-color: rgba(227, 35, 70, 1);
  background-color: rgba(227, 35, 70, var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, 1);
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(156, 163, 175, 1);
  background-color: rgba(156, 163, 175, var(--tw-bg-opacity));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, 1);
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgba(17, 24, 39, 1);
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(251, 213, 213, 1);
  background-color: rgba(251, 213, 213, var(--tw-bg-opacity));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(224, 36, 36, 1);
  background-color: rgba(224, 36, 36, var(--tw-bg-opacity));
}
.bg-skin-actionButton {
  background-color: var(--color-background-actionButton);
}
.bg-skin-alsoVisit {
  background-color: var(--color-background-alsoVisit);
}
.bg-skin-articleButton {
  background-color: var(--color-background-articleButton);
}
.bg-skin-fill {
  background-color: var(--color-background-body);
}
.bg-skin-missionTile {
  background-color: var(--color-background-missionTile);
}
.bg-skin-toggleButton {
  background-color: var(--color-background-toggleButton);
}
.bg-skin-volumeHeader {
  background-color: var(--color-background-volumeHeader);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.bg-white\\/50 {
  background-color: rgba(255, 255, 255, 0.5);
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-cover {
  background-size: cover;
}
.bg-right-bottom {
  background-position: right bottom;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-baseline {
  vertical-align: baseline;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-bs {
  font-size: 0.8125rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-xxs {
  font-size: .6875rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-3 {
  line-height: .75rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-tight {
  line-height: 1.25;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgba(28, 100, 242, 1);
  color: rgba(28, 100, 242, var(--tw-text-opacity));
}
.text-bsButtonColor {
  --tw-text-opacity: 1;
  color: rgba(23, 97, 145, 1);
  color: rgba(23, 97, 145, var(--tw-text-opacity));
}
.text-bsLinkColor {
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}
.text-bsRed {
  --tw-text-opacity: 1;
  color: rgba(227, 35, 70, 1);
  color: rgba(227, 35, 70, var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, 1);
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}
.text-mediumGray {
  --tw-text-opacity: 1;
  color: rgba(174, 174, 174, 1);
  color: rgba(174, 174, 174, var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgba(224, 36, 36, 1);
  color: rgba(224, 36, 36, var(--tw-text-opacity));
}
.text-skin-button {
  color: var(--color-text-button);
}
.text-skin-emailIcon {
  color: var(--color-text-emailIcon);
}
.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-beilstein {
  --tw-shadow: 4px 4px 5px 0 rgba(74,74,74,.7);
  --tw-shadow-colored: 4px 4px 5px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 4px 4px 5px 0 rgba(74,74,74,.7);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-button {
  --tw-shadow: 2px 2px 3px 0 rgba(0,0,0,.2);
  --tw-shadow-colored: 2px 2px 3px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 2px 2px 3px 0 rgba(0,0,0,.2);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-gray-500 {
  --tw-shadow-color: #6B7280;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-600 {
  --tw-shadow-color: #4B5563;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-700 {
  --tw-shadow-color: #374151;
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: blur(8px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.placeholder\\:text-xs::-moz-placeholder {
  font-size: 0.75rem;
  line-height: 1rem;
}
.placeholder\\:text-xs::placeholder {
  font-size: 0.75rem;
  line-height: 1rem;
}
.placeholder\\:text-white::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.placeholder\\:text-white::placeholder {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-0::after {
  content: var(--tw-content);
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.hover\\:border-3:hover {
  border-width: 3px;
}
.hover\\:border-bsBlue:hover {
  --tw-border-opacity: 1;
  border-color: rgba(0, 47, 92, 1);
  border-color: rgba(0, 47, 92, var(--tw-border-opacity));
}
.hover\\:border-bsLinkColor:hover {
  --tw-border-opacity: 1;
  border-color: rgba(0, 63, 123, 1);
  border-color: rgba(0, 63, 123, var(--tw-border-opacity));
}
.hover\\:border-bsRed:hover {
  --tw-border-opacity: 1;
  border-color: rgba(227, 35, 70, 1);
  border-color: rgba(227, 35, 70, var(--tw-border-opacity));
}
.hover\\:border-gray-200:hover {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(30, 66, 159, 1);
  background-color: rgba(30, 66, 159, var(--tw-bg-opacity));
}
.hover\\:bg-bsRed:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(227, 35, 70, 1);
  background-color: rgba(227, 35, 70, var(--tw-bg-opacity));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgba(28, 100, 242, 1);
  color: rgba(28, 100, 242, var(--tw-text-opacity));
}
.hover\\:text-bsBlue:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 47, 92, 1);
  color: rgba(0, 47, 92, var(--tw-text-opacity));
}
.hover\\:text-bsButtonColor:hover {
  --tw-text-opacity: 1;
  color: rgba(23, 97, 145, 1);
  color: rgba(23, 97, 145, var(--tw-text-opacity));
}
.hover\\:text-bsLinkColor:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 63, 123, 1);
  color: rgba(0, 63, 123, var(--tw-text-opacity));
}
.hover\\:text-bsRed:hover {
  --tw-text-opacity: 1;
  color: rgba(227, 35, 70, 1);
  color: rgba(227, 35, 70, var(--tw-text-opacity));
}
.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgba(75, 85, 99, 1);
  color: rgba(75, 85, 99, var(--tw-text-opacity));
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, 1);
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-75:hover {
  opacity: 0.75;
}
.focus\\:border-0:focus {
  border-width: 0;
}
.focus\\:border-b-2:focus {
  border-bottom-width: 2px;
}
.focus\\:border-none:focus {
  border-style: none;
}
.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, 1);
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(63, 131, 248, 1);
  border-color: rgba(63, 131, 248, var(--tw-border-opacity));
}
.focus\\:border-gray-200:focus {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, 1);
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
}
.focus\\:border-gray-300:focus {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
.focus\\:border-white:focus {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(164, 202, 254, var(--tw-ring-opacity));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(63, 131, 248, var(--tw-ring-opacity));
}
.focus\\:ring-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(229, 231, 235, var(--tw-ring-opacity));
}
.focus\\:ring-gray-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(209, 213, 219, var(--tw-ring-opacity));
}
.focus\\:ring-offset-0:focus {
  --tw-ring-offset-width: 0px;
}
.dark .dark\\:border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgba(63, 131, 248, 1);
  border-color: rgba(63, 131, 248, var(--tw-border-opacity));
}
.dark .dark\\:border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgba(75, 85, 99, 1);
  border-color: rgba(75, 85, 99, var(--tw-border-opacity));
}
.dark .dark\\:border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgba(55, 65, 81, 1);
  border-color: rgba(55, 65, 81, var(--tw-border-opacity));
}
.dark .dark\\:border-transparent {
  border-color: transparent;
}
.dark .dark\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(28, 100, 242, 1);
  background-color: rgba(28, 100, 242, var(--tw-bg-opacity));
}
.dark .dark\\:bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(75, 85, 99, 1);
  background-color: rgba(75, 85, 99, var(--tw-bg-opacity));
}
.dark .dark\\:bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 65, 81, 1);
  background-color: rgba(55, 65, 81, var(--tw-bg-opacity));
}
.dark .dark\\:bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, 1);
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity));
}
.dark .dark\\:bg-gray-800\\/50 {
  background-color: rgba(31, 41, 55, 0.5);
}
.dark .dark\\:bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.dark .dark\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgba(63, 131, 248, 1);
  color: rgba(63, 131, 248, var(--tw-text-opacity));
}
.dark .dark\\:text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}
.dark .dark\\:text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.dark .dark\\:hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(26, 86, 219, 1);
  background-color: rgba(26, 86, 219, var(--tw-bg-opacity));
}
.dark .dark\\:hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(75, 85, 99, 1);
  background-color: rgba(75, 85, 99, var(--tw-bg-opacity));
}
.dark .dark\\:hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, 1);
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity));
}
.dark .dark\\:hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgba(63, 131, 248, 1);
  color: rgba(63, 131, 248, var(--tw-text-opacity));
}
.dark .dark\\:hover\\:text-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgba(209, 213, 219, 1);
  color: rgba(209, 213, 219, var(--tw-text-opacity));
}
.dark .dark\\:hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
@media (min-width: 480px) {

  .sm\\:block {
    display: block;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:px-28 {
    padding-left: 7rem;
    padding-right: 7rem;
  }
}
@media (min-width: 768px) {

  .md\\:inset-0 {
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .md\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:ml-0 {
    margin-left: 0px;
  }

  .md\\:ml-2 {
    margin-left: 0.5rem;
  }

  .md\\:ml-4 {
    margin-left: 1rem;
  }

  .md\\:mr-0 {
    margin-right: 0px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-4 {
    margin-top: 1rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:max-h-12 {
    max-height: 3rem;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-2\\/5 {
    width: 40%;
  }

  .md\\:w-20 {
    width: 5rem;
  }

  .md\\:w-3\\/5 {
    width: 60%;
  }

  .md\\:w-36 {
    width: 9rem;
  }

  .md\\:w-64 {
    width: 16rem;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:flex-wrap {
    flex-wrap: wrap;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * 0);
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * (1 - 0));
    margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - 0));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * 0);
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * (1 - 0));
    margin-left: calc(0.75rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - 0));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * (1 - 0));
    margin-top: calc(0px * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(0px * calc(1 - 0));
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * 0);
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .md\\:place-self-start {
    align-self: start;
    justify-self: start;
    place-self: start;
  }

  .md\\:justify-self-start {
    justify-self: start;
  }

  .md\\:justify-self-end {
    justify-self: end;
  }

  .md\\:justify-self-stretch {
    justify-self: stretch;
  }

  .md\\:border-0 {
    border-width: 0;
  }

  .md\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-1 {
    padding: 0.25rem;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:pl-0 {
    padding-left: 0px;
  }

  .md\\:pr-0 {
    padding-right: 0px;
  }

  .md\\:pr-20 {
    padding-right: 5rem;
  }

  .md\\:pr-4 {
    padding-right: 1rem;
  }

  .md\\:pr-8 {
    padding-right: 2rem;
  }

  .md\\:pt-6 {
    padding-top: 1.5rem;
  }

  .md\\:text-right {
    text-align: right;
  }
}
@media (min-width: 970px) {

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/resources/static/css/style.tailwind.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,8LAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,0BAAc;EAAd,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,wBAAc;KAAd,qBAAc;UAAd,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,8BAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,mGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,yDAAc;EAAd,yCAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,sBAAc;EAAd,yBAAc;EAAd,wBAAc;EAAd,4BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,0BAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,mCAAc;UAAd;AAAc;;AAAd;EAAA,wBAAc;KAAd,qBAAc;UAAd,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;KAAd,sBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,mGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,8BAAc;EAAd,yBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iFAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,kBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,mBAAc;EAAd,eAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,kBAAc;EAAd,kBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,8MAAc;EAAd,oGAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,kBAAc;EAAd,aAAc;EAAd,cAAc;EAAd,iBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,cAAc;EAAd,gJAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,4BAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;EAAd;IAAA,8BAAc;IAAd,iCAAc;EAAA;;EAAd;IAAA,qBAAc;IAAd,6BAAc;IAAd,+BAAc;;IAAd,2BAAc;IAAd,gCAAc;IAAd,qCAAc;IAAd,uCAAc;IAAd,wCAAc;IAAd,yCAAc;IAAd,wCAAc;IAAd,wCAAc;;IAAd,uBAAc;IAAd,iCAAc;EAAA;;EAAd;IAAA,qBAAc;IAAd,6BAAc;IAAd,+BAAc;;IAAd,2BAAc;IAAd,gCAAc;IAAd,qCAAc;IAAd,uCAAc;IAAd,wCAAc;IAAd,yCAAc;IAAd,wCAAc;IAAd,wCAAc;;IAAd,uBAAc;IAAd,iCAAc;EAAA;;;EAAd;IAAA,yCAAc;EAAA;;;EAAd;IAAA,uBAAc;EAAA;;EAAd;EAAA,gBAAc;EAAd,mBAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;EAAA;AAAc;;EAAd;EAAA,mBAAc;EAAd,oBAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;;GAAd;EAAA,gBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;;;EAAd;EAAA,kBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,iCAAc;EAAd,wDAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,kBAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,yBAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,kBAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,yBAAc;EAAd,oBAAc;EAAd,6BAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd,qBAAc;EAAd,oBAAc;EAAd,uBAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd;AAAc;;EAAd;EAAA,iBAAc;EAAd,sBAAc;EAAd,gCAAc;EAAd,uDAAc;EAAd,oBAAc;EAAd,yBAAc;EAAd;AAAc;EAAd;EAAA,qBAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd,qBAAc;EAAd,oBAAc;EAAd,uBAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,yBAAc;EAAd,oBAAc;EAAd,6BAAc;EAAd;AAAc;EAAd;EAAA,iBAAc;EAAd,sBAAc;EAAd,gCAAc;EAAd,uDAAc;EAAd,oBAAc;EAAd,yBAAc;EAAd;AAAc;;EAAd;EAAA,sBAAc;EAAd,gCAAc;EAAd,uDAAc;EAAd,oBAAc;EAAd,yBAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,aAAc;EAAd,YAAc;EAAd,WAAc;EAAd,mBAAc;EAAd,uBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,kBAAc;EAAd,oBAAc;EAAd,6BAAc;EAAd;AAAc;;EAAd;EAAA,sBAAc;EAAd,iCAAc;EAAd,wDAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;EAAA,oBAAc;EAAd,aAAc;EAAd,YAAc;EAAd,mBAAc;EAAd,uBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd,qBAAc;EAAd,kBAAc;EAAd,oBAAc;EAAd,6BAAc;EAAd;AAAc;;EAAd;EAAA,sBAAc;EAAd,iCAAc;EAAd,wDAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;;EAAA,sBAAc;EAAd,iCAAc;EAAd,wDAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;;EAAA,eAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd,6BAAc;EAAd;AAAc;;EAAd;;EAAA,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,kBAAc;EAAd,wCAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd,6BAAc;EAAd;AAAc;;;;EAAd;EAAA,qBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd,6BAAc;EAAd;AAAc;;EAAd;EAAA,qBAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd,6BAAc;EAAd;AAAc;;EAAd;IAAA,kBAAc;EAAA;;EAAd;IAAA,kBAAc;EAAA;;EAAd;IAAA,2BAAc;IAAd,gCAAc;IAAd;EAAc;;EAAd;;IAAA;EAAc;;EAAd,uDAAc;EAAd,iDAAc;EAAd,uDAAc;EAAd;EAAA,gBAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,WAAc;EAAd,oBAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd,wCAAc;EAAd;AAAc;;;EAAd;EAAA,kBAAc;EAAd,wCAAc;EAAd;AAAc;;;EAAd;;EAAA,mBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd,uBAAc;EAAd,oBAAc;EAAd,qBAAc;EAAd;AAAc;;EAAd;EAAA,wBAAc;EAAd,sBAAc;EAAd,iCAAc;EAAd;AAAc;;;EAAd,uDAAc;EAAd,uDAAc;EAAd,uDAAc;;EAAd;EAAA,oBAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd;AAAc;;EAAd;EAAA,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd;AAAc;;EAAd;EAAA,gBAAc;EAAd,eAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd;AAAc;;EAAd;EAAA;AAAc;;EAAd;EAAA,gBAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,WAAc;EAAd,oBAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd,wCAAc;EAAd;AAAc;;;EAAd;EAAA,kBAAc;EAAd,wCAAc;EAAd;AAAc;;;EAAd;;EAAA,mBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd,uBAAc;EAAd,oBAAc;EAAd,qBAAc;EAAd;AAAc;;EAAd;EAAA,wBAAc;EAAd,sBAAc;EAAd,iCAAc;EAAd;AAAc;;;EAAd;;EAAA,mBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd,oBAAc;EAAd,uBAAc;EAAd,oBAAc;EAAd,qBAAc;EAAd;AAAc;;EAAd;EAAA,oBAAc;EAAd,6BAAc;EAAd,kDAAc;EAAd;AAAc;;EAAd;EAAA,aAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,8BAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,gBAAc;EAAd;AAAc;;EAAd;EAAA,qBAAc;EAAd;AAAc;;EAAd;EAAA,mBAAc;EAAd,gBAAc;EAAd;AAAc;;EAAd;EAAA,qBAAc;EAAd;AAAc;;EAAd,uDAAc;EAAd,sDAAc;EAAd,uDAAc;;EAAd;EAAA;AAAc;;EAAd;EAAA;AAAc;EAAd;EAAA;AAAc;;EAAd;EAAA;AAAc;;;EAAd;EAAA;AAAc;;EAAd;EAAA,qBAAc;EAAd,gBAAc;EAAd,uBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd;AAAc;;EAAd;EAAA,gBAAc;EAAd,uBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd;AAAc;;EAAd;EAAA;AAAc;;EAAd;EAAA,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;EAAA,gBAAc;EAAd,WAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd;AAAc;;EAAd;EAAA,wBAAc;EAAd,sBAAc;EAAd,oCAAc;EAAd,2DAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd,wCAAc;EAAd;AAAc;;EAAd;EAAA;AAAc;;EAAd;EAAA,mBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,oBAAc;EAAd,0BAAc;EAAd;AAAc;EAAd;EAAA,wBAAc;EAAd,mBAAc;EAAd;AAAc;;EAAd;EAAA,iBAAc;EAAd,4BAAc;EAAd,mBAAc;EAAd;AAAc;;EAAd,yCAAc;EAAd,0BAAc;EAAd,IAAc;;EAAd;EAAA,gBAAc;EAAd,oBAAc;EAAd,2BAAc;EAAd;AAAc;;EAAd;EAAA,oBAAc;EAAd;AAAc;;EAAd;EAAA,oBAAc;EAAd;AAAc;;EAAd;EAAA,oBAAc;EAAd,0BAAc;EAAd;AAAc;;EAAd;EAAA,gBAAc;EAAd,uBAAc;EAAd,kBAAc;EAAd;AAAc;;EAAd;EAAA;AAAc;;EAAd;EAAA,gBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd;AAAc;;EAAd;EAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+KAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8KAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qLAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4BAAmB;EAAnB,oDAAmB;EAAnB,iCAAmB;EAAnB,yDAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+BAAmB;EAAnB,uDAAmB;EAAnB,oCAAmB;EAAnB,4DAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8BAAmB;EAAnB,sDAAmB;EAAnB,mCAAmB;EAAnB,2DAAmB;EAAnB,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,kCAAmB;EAAnB,0DAAmB;EAAnB,sCAAmB;EAAnB,8DAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,8FAAmB;EAAnB,mHAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,yDAAmB;EAAnB,iFAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,yDAAmB;EAAnB,8EAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,mGAAmB;EAAnB,wHAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,iGAAmB;EAAnB,sHAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,4KAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAFnB;EAAA,kBAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,6BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,6BAkXC;EAlXD;AAkXC;AAlXD;EAAA,0BAkXC;EAlXD;AAkXC;AAlXD;EAAA,0BAkXC;EAlXD,QAkXC;EAlXD,UAkXC;EAlXD,WAkXC;EAlXD;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,gCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,iCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,kCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,oCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,oCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,sCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,sCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,wCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,wCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,wCAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,uBAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,4BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,yBAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,2BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,0BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,2BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,0BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,0BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,6BAkXC;EAlXD;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,8BAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,mCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,oCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,oCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,oCAkXC;EAlXD;AAkXC;AAlXD;EAAA,8BAkXC;EAlXD;AAkXC;AAlXD;EAAA,2GAkXC;EAlXD,yGAkXC;EAlXD,0MAkXC;EAlXD;AAkXC;AAlXD;EAAA,2GAkXC;EAlXD,yGAkXC;EAlXD,0MAkXC;EAlXD;AAkXC;AAlXD;EAAA,2GAkXC;EAlXD,yGAkXC;EAlXD,0MAkXC;EAlXD;AAkXC;AAlXD;EAAA,2GAkXC;EAlXD,yGAkXC;EAlXD,0MAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,mCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,iCAkXC;EAlXD;AAkXC;AAlXD;EAAA,sBAkXC;EAlXD,iCAkXC;EAlXD;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,uCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,qCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,qCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,qCAkXC;EAlXD;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,4BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,6BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,6BAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,sCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,qCAkXC;EAlXD;AAkXC;AAlXD;EAAA,kBAkXC;EAlXD,qCAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,4BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,6BAkXC;EAlXD;AAkXC;AAlXD;EAAA,oBAkXC;EAlXD,6BAkXC;EAlXD;AAkXC;AAlXD;;EAAA;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA,kBAkXC;IAlXD;EAkXC;AAAA;AAlXD;;EAAA;IAAA,QAkXC;IAlXD,UAkXC;IAlXD,WAkXC;IAlXD;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA,gBAkXC;IAlXD;EAkXC;;EAlXD;IAAA,iBAkXC;IAlXD;EAkXC;;EAlXD;IAAA,oBAkXC;IAlXD;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA,uBAkXC;IAlXD,8BAkXC;IAlXD,sDAkXC;IAlXD,mCAkXC;IAlXD,2DAkXC;IAlXD,uCAkXC;IAlXD;EAkXC;;EAlXD;IAAA,uBAkXC;IAlXD,+BAkXC;IAlXD,uDAkXC;IAlXD,oCAkXC;IAlXD,4DAkXC;IAlXD,wCAkXC;IAlXD;EAkXC;;EAlXD;IAAA,uBAkXC;IAlXD,+BAkXC;IAlXD,uDAkXC;IAlXD,mCAkXC;IAlXD,2DAkXC;IAlXD,4BAkXC;IAlXD;EAkXC;;EAlXD;IAAA,iBAkXC;IAlXD,mBAkXC;IAlXD;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA,kBAkXC;IAlXD,wCAkXC;IAlXD;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA,iBAkXC;IAlXD;EAkXC;;EAlXD;IAAA,oBAkXC;IAlXD;EAkXC;;EAlXD;IAAA,kBAkXC;IAlXD;EAkXC;;EAlXD;IAAA,qBAkXC;IAlXD;EAkXC;;EAlXD;IAAA,oBAkXC;IAlXD;EAkXC;;EAlXD;IAAA,gBAkXC;IAlXD;EAkXC;;EAlXD;IAAA,mBAkXC;IAlXD;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;AAAA;AAlXD;;EAAA;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA;EAkXC;;EAlXD;IAAA,iBAkXC;IAlXD;EAkXC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n@layer base {\n\n  :root{\n    /*--color-text-link: #003f7b;*/\n    /*--color-text-button:  #003f7b;*/\n  }\n\n  .theme-bjoc {\n    /* text definitions */\n    --color-text-button:  #003f7b;\n    --color-text-emailIcon: #176191;\n\n    /* background definitions */\n    --color-background-body: #79838A;\n    --color-background-alsoVisit: #4a4a4a;\n    --color-background-missionTile: #176191;\n    --color-background-toggleButton: #176191;\n    --color-background-articleButton: #176191;\n    --color-background-actionButton: #003f7b;\n    --color-background-volumeHeader: #176191;\n\n    /* border definitions */\n    --color-border-separator: #176191;\n  }\n\n  .theme-bjnano {\n    /* text definitions */\n    --color-text-button:  #003f7b;\n    --color-text-emailIcon: #ED713B;\n\n    /* background definitions */\n    --color-background-body: #78726F;\n    --color-background-alsoVisit: #4a4a4a;\n    --color-background-missionTile: #ED713B;\n    --color-background-toggleButton: #176191;\n    --color-background-articleButton: #ED713B;\n    --color-background-actionButton: #003f7b;\n    --color-background-volumeHeader: #ED713B;\n\n    /* border definitions */\n    --color-border-separator: #ED713B;\n  }\n\n\n  html {\n    scroll-behavior: smooth;\n    font-family: Arial, sans-serif !important;\n  }\n\n  p {\n    @apply text-sm mt-4\n  }\n\n  h1 {\n    @apply text-bsLinkColor text-xl font-medium\n  }\n\n  h2 {\n    @apply text-bsLinkColor text-base font-medium mt-2\n  }\n\n  h2.aside-box  {\n    @apply mt-2\n  }\n\n  h3 {\n    @apply text-bsLinkColor text-sm\n  }\n\n   h4 {\n    @apply text-bsLinkColor text-sm my-4\n  }\n\n\n  .authors {\n    @apply pt-4 list-none pl-0 mb-0\n  }\n\n  .pwsButtonBlue {\n    @apply border-3 border-bsLinkColor p-1 px-3 text-center text-xs font-semibold text-bsLinkColor whitespace-nowrap uppercase\n  }\n\n  .pwsButtonWhite {\n    @apply border-3 border-white p-1 px-3 text-center text-xs font-semibold text-white whitespace-nowrap uppercase\n  }\n\n  .pwsButtonNav {\n    @apply border-3 border-white px-2 py-1 text-xs whitespace-nowrap uppercase hover:border-3 hover:border-bsBlue hover:text-bsBlue\n  }\n  .pwsButtonNavMobile {\n    @apply mb-2 block border-3 border-white text-xs text-white px-2 py-1 whitespace-nowrap uppercase hover:border-3 hover:border-bsBlue hover:text-bsBlue\n  }\n\n  .pwsButtonNav.selected , .pwsButtonNavMobile.selected{\n    @apply border-bsBlue text-bsBlue\n  }\n\n  .pwsPagerButton {\n    @apply flex items-center justify-center ml-2 h-8 w-8 text-white text-center border-3 border-white hover:border-bsLinkColor hover:text-bsLinkColor\n  }\n\n  .pwsVolumePagerButton {\n    @apply flex items-center justify-center ml-1 h-8 px-2 text-white text-center border-3 border-white hover:border-bsLinkColor  hover:text-bsLinkColor\n  }\n\n  .pwsPagerButton.selected,\n  .pwsVolumePagerButton.selected {\n    @apply  border-bsLinkColor text-bsLinkColor\n  }\n\n  .pwsPagerButton.disabled,\n  .pwsVolumePagerButton.disabled {\n    @apply border-gray-400 text-gray-400 hover:border-gray-400 hover:bg-bsBackground hover:text-gray-400  cursor-default\n  }\n\n\n\n  .ga-toggle-button{\n    @apply text-white px-4 py-1.5 rounded-full text-bs font-semibold\n  }\n\n  .accordion-toggle-button{\n    @apply text-white p-2 rounded-full text-bs font-semibold\n  }\n\n  input:focus::placeholder {\n    color: transparent;\n  }\n\n  select#searchOptions {\n    appearance: none !important;\n    -moz-appearance: none !important;\n    -webkit-appearance: none !important;\n\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\")\n  }\n\n  /* ================================================== */\n  /* Definitions for table iframes                */\n  /* ================================================== */\n  figure .table-responsive {\n    @apply overflow-x-auto min-h-[.01%]\n  }\n\n  figure .table {\n    @apply w-full text-bs leading-8 mb-4\n  }\n\n  figure .table tr {\n    @apply hover:bg-gray-100\n  }\n\n\n  figure .suppinfo-table tr {\n    @apply hover:bg-gray-100\n  }\n\n\n  figure .table tr>td,\n  figure .table tr>th {\n    @apply border-t-0 border-b border-gray-200 font-normal  py-1 px-2\n  }\n\n  figure .table .separator {\n    @apply border-b border-gray-700\n  }\n\n\n  /* ================================================== */\n  /* Definitions for the article content                */\n  /* ================================================== */\n\n  #articleContent p {\n    @apply leading-[1.3125rem] text-bs\n  }\n\n  #articleContent p.small {\n    @apply text-xs\n  }\n\n  #articleContent a {\n    @apply text-bsLinkColor\n  }\n\n  #articleContent h2 {\n    @apply text-lg\n  }\n\n  #articleContent h3 {\n    @apply text-base mt-4\n  }\n\n  #articleContent .bs-separator {\n    @apply my-5 border-t border-lightGray\n  }\n\n  #articleContent figure {\n    @apply w-full\n  }\n\n  #articleContent .table-responsive {\n    @apply overflow-x-auto min-h-[.01%]\n  }\n\n  #articleContent .table {\n    @apply w-full text-bs leading-8 mb-4\n  }\n\n  #articleContent .table tr {\n    @apply hover:bg-gray-100\n  }\n\n\n  #articleContent .suppinfo-table tr {\n    @apply hover:bg-gray-100\n  }\n\n\n  #articleContent .table tr>td,\n  #articleContent .table tr>th {\n    @apply border-t-0 border-b border-gray-200 font-normal  py-1 px-2\n  }\n\n  #articleContent .table .separator {\n    @apply border-b border-gray-700\n  }\n\n\n  #articleContent .suppinfo-table tr>td,\n  #articleContent .suppinfo-table tr>th {\n    @apply border-t-0 border-b border-gray-200 font-normal py-1 px-2\n  }\n\n  #articleContent .singleLicense a {\n    @apply text-white;\n    @apply underline;\n  }\n\n  #articleContent .reference-list li {\n    @apply mt-3\n  }\n\n  #articleContent .equation {\n    @apply flex flex-row justify-between items-center p-4\n  }\n\n  #articleContent .reftooltip {\n    /* background-color: red !important; */\n  }\n\n  #articleContent ul {\n    @apply list-square ml-6 mt-4\n  }\n\n  #articleContent ul li {\n    @apply py-1.5\n  }\n\n  #articleContent ol {\n    @apply list-decimal ml-6 mt-4\n  }\n\n  #articleContent ol li {\n    @apply py-1.5\n  }\n\n  /* ================================================== */\n  /* Definitions for the static content                */\n  /* ================================================== */\n\n  .sc h2 {\n    @apply mt-6\n  }\n\n  .sc h3 {\n    @apply mt-4\n  }\n  .sc .margin-top__normal{\n    @apply mt-4\n  }\n\n  .sc .margin-top__small{\n    @apply mt-2\n  }\n\n\n  .sc .margin-bottom__large {\n    @apply mb-16\n  }\n\n  .sc .narrow {\n    @apply my-2 mt-4 px-4 list-square text-sm\n  }\n\n  .sc ul {\n    @apply mt-4 px-4 list-square text-sm\n  }\n\n  .sc ul li {\n    @apply mt-2\n  }\n\n  .sc a {\n    @apply text-bsLinkColor\n  }\n\n  .sc table {\n    @apply mt-4 px-4 text-sm w-full\n  }\n\n  .sc table tr {\n    @apply p-4 border-b border-gray-100 hover:bg-gray-100\n  }\n\n  .sc table tr > td {\n    @apply p-2\n  }\n\n  .sc .toc-list {\n    @apply text-sm ml-6 text-bsLinkColor mt-2\n  }\n  .sc ol.decimal {\n    @apply list-decimal text-sm\n  }\n\n  .sc ol.decimal ol.lower-alpha {\n    @apply list-[lower-alpha] ml-4 text-sm\n  }\n\n  /*.sc ol.decimal li, ol.lower-alpha li {*/\n  /*  @apply py-0.5 text-sm*/\n  /*}*/\n\n  .sc .top {\n    @apply text-bsRed font-semibold\n  }\n\n  .series-sc {\n    @apply text-bs leading-[1.3125rem]\n  }\n\n  .series-sc p {\n    @apply text-bs leading-[1.3125rem]\n  }\n\n  .series-sc a {\n    @apply text-bsLinkColor\n  }\n\n  .series-sc ul {\n    @apply mt-4 px-4 list-square\n  }\n\n  .series-sc ul li {\n    @apply mt-2\n  }\n\n  .series-sc ol {\n    @apply mt-4 px-4 list-decimal\n  }\n\n  .series-sc ol li {\n    @apply mt-2\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
